<template>
	<section style="background:#F8F9FD;">
		<div class="py-6 px-6 container">
			<div v-if="!hideHistoricBtn" class="is-flex is-justify-content-flex-end m-1">
				<b-button class="" type="is-info" @click="() => modalHistoricFiles()">Historico</b-button>
			</div>

			<div v-for="(doc, iDoc) in getFileTypes()" :key="doc.name" class="card p-5 mb-5">
				<div class="is-justify-content-center has-text-left mb-5 mt-5">
					<p class="title has-text-weight-semibold">
						{{ iDoc + 1 }}.- {{ doc.desc }}
					</p>
				</div>
				<div class="pl-6 is-justify-content-center has-text-centered mb-2">
					<form-obligation-generic v-bind:key="'otras obligaciones'" :msgTitle="doc.info"
						:msgBtn="'Subir planilla de ' + doc.desc.toLowerCase()"
						msgValidateBtn="Esperamos que el servidor confirme que el archivo quedo guardado."
						:msgUpdateUntil="'Tu última subida de ' + doc.desc.toLowerCase() + ' fue en '"
						:msgNotificationUpdate="'Recuerda actualizar tu libro de ' + doc.desc.toLowerCase()"
						:kind_file="doc.name" :hideErrors="false" :showMsgRemember="false"
						:disableUploadBtn="disableUploadBtn"
						:nodate="true"
						@openModal="modalBookRemunerations($event, getModalTexts(doc))" />
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import { getUrlsFilesHistory } from "@/api/uploadFiles";
import BookRemunerations from "@/components/modals/BookRemunerations";
import HistoricFiles from "@/components/modals/HistoricFiles";
import FormObligationGeneric from "@/components/obligations/formObligationFile/FormObligationGeneric";
import { mapMutations, mapState } from "vuex";
export default {
	name: "DashboardFileUpload",
	components: {
		FormObligationGeneric,
	},
	data() {
		return {
			filesToShow: [],
			modalDefault: {
				parent: this,
				hasModalCard: true,
				customClass: "modal-class",
				canCancel: ["escape", "outside"],
			},
		}
	},
	methods: {
		...mapMutations("bookRemunerations", [
			"SET_STATUS_FOR_FILES",
		]),
		modalHistoricFiles() {
			let allData = {}
			getUrlsFilesHistory().then(({ data }) => {
				data.map(
					(current) => {
						if (!allData[current.kind_file]) {
							allData[current.kind_file] = []
						}
						if (allData[current.kind_file].length < 10) {
							allData[current.kind_file].push(current)
						}
					}
				)
				return allData
			}).catch(() => {
				allData = {}
				return allData
			}).finally(() => {
				this.$buefy.modal.open({
					...this.modalDefault,
					component: HistoricFiles,
					props: {
						files: allData,
					},
				});
			})

		},
		modalBookRemunerations(newProps, modalTexts) {
			this.$buefy.modal.open({
				...this.modalDefault,
				component: BookRemunerations,
				props: {
					...newProps,
					...modalTexts,
					userIdSuplanted: this.userIdSuplanted
				},
				events: {
					cleanError: () => {
						this.SET_STATUS_FOR_FILES(true)
					},
				},
			});
		},
		getModalTexts(fileType) {
			return {
				titleModal: fileType.desc,
				msgHelp: fileType.msgHelp,
				listHelp: fileType.listHelp,
				planillaName: "libro_de_otras_obligaciones",
				msgFileName: fileType.desc,
				fileName: fileType.desc,
				kind_file: fileType.name,
				hideDefaultPlanilla: true,
				msgUpload: fileType.msgUpload,
				messageFormat: "XLSX, PDF, Imagenes",
				extensionAccept: ".xlsx,application/pdf,image/*",
			}
		},
		getFileTypes() {
			if (!this.filesToShow) {
				return []
			}
			this.filesToShow.map(fileType => {
				if (fileType.name == "remuneraciones") {
					fileType.msgHelp = "Subir tus Libro de Remuneraciones nos permitirá:"
					fileType.listHelp = [
						"Construir una base de datos con toda la información de Sueldos, Imposiciones e Impuestos Únicos históricas.",
						"Clasificar a cada trabajador dentro de un equipo en tu plan de cuentas."
					]
					fileType.msgUpload = "Consigue tus libros de remuneraciones en tu ordenador"
				} else if (fileType.name == "facturas_extranjeras") {
					fileType.msgHelp = "Subir tus facturas o invoices extranjeros nos permitirá:"
					fileType.listHelp = [
						"Construir una base de datos con toda la información de servicios recibidos por proveedores extranjeros.",
						"Clasificar a cada proveedor dentro de una cuenta en tu plan de cuentas."
					]
					fileType.msgUpload = 'Arma el registro de tus facturas por servicios de proveedores extranjeros'
				} else if (fileType.name == "recibos") {
					fileType.msgHelp = "Subir tus recibos nos permitirá:"
					fileType.listHelp = [
						"Construir una base de datos con toda la información de servicios recibidos sin respaldo en SII.",
						"Clasificar a cada proveedor de estos servicios dentro de una cuenta en tu plan de cuentas."
					]
					fileType.msgUpload = 'Arma el registro de tus recibos por servicios no respaldados en SII'
				} else if (fileType.name == "finiquitos") {
					fileType.msgHelp = "Subir tus finiquitos nos permitirá:"
					fileType.listHelp = [
						"Construir una base de datos con toda la información de los finiquitos que han ocurrido en tu empresa.",
					]
					fileType.msgUpload = "Arma el registro de tus finiquitos"
				} else if (fileType.name == "exportable_erp") {
					fileType.msgHelp = "Subir tus exportables nos permitirá:"
					fileType.listHelp = [
						"Acceder a la data financiera alojada en los distintos software que utilices para la gestión de tu empresa.",
						"Construir una base de datos enriquecida para tus reportes financieros."
					]
					fileType.msgUpload = "Descarga la data desde tu ERP"
				} else if (fileType.name == "creditos") {
					fileType.msgHelp = "Subir tus tablas de desarrollo de créditos nos permitirá:"
					fileType.listHelp = [
						"Construir una base de datos con toda la información de la deuda de tu empresa.",
					]
					fileType.msgUpload = "Consigue las distintas tablas de desarrollo de créditos"
				} else if (fileType.name == "balance_8_columnas") {
					fileType.msgHelp = "Subir tus balances nos permitirá:"
					fileType.listHelp = [
						"Acceder a la data de los estados financieros ya trabajada por tu contador.",
						"Validar contra nuestros reportes la información de los balances que ha trabajado tu contador.",
						"Avisar de posibles ajustes que debe realizar tu contador para efectos tributarios y financieros.",
						"Contar con información financiera actualizada para posibles procesos de financiamiento."
					]
					fileType.msgUpload = "Consigue tus balances 8 columnas "
				} else if (fileType.name == "libro_bancos") {
					fileType.msgHelp = "Subir tus libros banco nos permitirá:"
					fileType.listHelp = [
						"Acceder a la data de flujo de caja histórica de tu empresa.",
						"Clasificar cada movimiento a una cuenta de tu plan de cuentas"
					]
					fileType.msgUpload = "Arma tus libros banco"
				} else if (fileType.name == "data_operacional_complementaria") {
					fileType.msgHelp = "Subir tus data operacional complementaria nos permitirá:"
					fileType.listHelp = [
						"Acceder a la data operacional de tu empresa normalmente alojada en softwares desarrollados internamente u otros.",
						"Construir una base de datos enriquecida para tus reportes financieros."
					]
					fileType.msgUpload = "Arma tu data operacional"
				}
			})
			return this.filesToShow
		}
	},
	computed: {
		...mapState("userAuth", ["user"]),
	},
	props: ["fileId", "hideHistoricBtn", "filesByUser", "disableUploadBtn", "userIdSuplanted"],
	created() {
		if (!this.fileId) {
			this.filesToShow = this.user.filetypes
		} else {
			this.filesToShow = this.filesByUser.filter(file => file.id == this.fileId)
		}
	},
	watch: {
		'user.filetypes': function (updated) {
			this.filesToShow = updated
		}
	}
}
</script>

<style>
.center-div {
	width: 100%;
	height: 90%;
	margin: auto;
}

@media screen and (max-width: 768px) {
	.center-div {
		display: block;
	}
}

.segunda-linea-pagar {
	font-size: 80%;
}

.pagar-button {
	position: relative;
	bottom: 3px;
}
</style>